import type { Notification } from "../../common/types/notificationTypes";

export const filterOldNotifications = (notifications: Notification[], activeNotifications: Notification[]) =>
   notifications.filter(
      (notification) => !activeNotifications.some((activeNotification) => notification.id === activeNotification.id)
   );

export const getNotificationsTrackingText = (
   menuItemName: string,
   notificationsCount: number,
   newPromotionArticlesCount: number
) => {
   if (
      (notificationsCount > 0 && menuItemName === "Varslinger") ||
      (newPromotionArticlesCount > 0 && menuItemName === "Kampanjer")
   ) {
      return `${menuItemName} med varsel`;
   }
   return menuItemName;
};
